import script from "./JobList.vue?vue&type=script&setup=true&lang=ts"
export * from "./JobList.vue?vue&type=script&setup=true&lang=ts"

import "./JobList.vue?vue&type=style&index=0&id=b5f0cdd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5f0cdd0"]])

export default __exports__